import { Component, Element, Prop, Listen, h } from '@stencil/core';
/**
 * @internal
 */

const rippleClass = {
  content: '',
  display: 'block',
  position: 'absolute',
  borderRadius: '50%',
  transform: 'scale(0)',
  animation: 'var(--ripple-animation)',
  backgroundColor: 'rgba(255, 255, 255, 0.7)',
  width: 'var(--ripple-diameter)',
  height: 'var(--ripple-diameter)',
  top: 'var(--ripple-top)',
  left: 'var(--ripple-left)',
  pointerEvents: 'none',
  opacity: 1,
  transition: 'transform 600ms linear, opacity 600ms linear',
};

@Component({
  tag: 'ripple-wrapper',
  styleUrl: 'ripple-wrapper.css',
  shadow: true,
})
export class RippleWrapper {
  @Prop() hasScrollableParent: boolean = false;
  @Prop() disabled: boolean = false;
  @Element() el: HTMLElement;

  @Listen('mousedown')
  handleMouseDown(event: MouseEvent) {
    if (event?.button === 0 && !this.disabled) this.createRipple(event);
  }

  private createRipple(event: MouseEvent) {
    // Get Slotted Content
    const slot = this.el.shadowRoot.querySelector('slot');
    const slottedNodes = slot.assignedNodes();
    const button = Array.from(slottedNodes).find(node => node.nodeType === Node.ELEMENT_NODE) as HTMLElement;

    if (!button) return;

    // Create Span
    const ripple = document.createElement('span');
    Object.assign(ripple.style, rippleClass);
    button.appendChild(ripple);

    const diameter = Math.min(button.clientWidth, button.clientHeight);
    const radius = diameter / 2;
    const left = event.clientX - (button.offsetLeft + radius);
    const scrollableParent = document.querySelector('div[slot="content"]')?.parentElement?.shadowRoot?.querySelector('#contentWrapper');
    const top = event.clientY + (this.hasScrollableParent ? scrollableParent?.scrollTop || 0 : 0) - (button.offsetTop + radius);

    button.style.setProperty('--ripple-diameter', `${diameter}px`);
    button.style.setProperty('--ripple-left', `${left}px`);
    button.style.setProperty('--ripple-top', `${top}px`);

    // Animate
    requestAnimationFrame(() => {
      ripple.style.transform = 'scale(4)';
      ripple.style.opacity = '0';
    });

    let transitionsCompleted = 0;
    ripple.addEventListener('transitionend', event => {
      if (event.propertyName === 'transform' || event.propertyName === 'opacity') {
        transitionsCompleted++;
        if (transitionsCompleted === 2) {
          ripple.remove();
        }
      }
    });
  }

  render() {
    return <slot></slot>;
  }
}
